import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import type { PublicEpisode, PublicLive, PublicShow } from '../api/types'

const publicKey = ['public'] as const

export function usePublicShow(workspace: string, show: string) {
  return useQuery({
    queryKey: [...publicKey, workspace, show],
    queryFn: () => api<PublicShow>(`/public/shows/${workspace}/${show}`),
    retry: false,
  })
}

export function usePublicEpisode(workspace: string, show: string, episode: string) {
  return useQuery({
    queryKey: [...publicKey, workspace, show, episode],
    queryFn: () => api<PublicEpisode>(`/public/shows/${workspace}/${show}/episodes/${episode}`),
    retry: false,
  })
}

/** Whether a show is on air, checked every ten seconds (until the show turns out not to go live). */
export function usePublicLive(workspace: string, show: string) {
  return useQuery({
    queryKey: [...publicKey, 'live', workspace, show],
    queryFn: () => api<PublicLive>(`/public/shows/${workspace}/${show}/live`),
    retry: false,
    refetchInterval: (query) => (query.state.status === 'error' ? false : 10_000),
  })
}
